import React, { Component } from "react";

import Slider from "../../../components/Slider";
import Graph from "../../../components/graphs/EntitySectorGraph";
import ChannelsDropdown from "./channelsDropdown";
import IndicatorsDropdown from "./indicatorsDropdown";
import {
  Main,
  GraphDetailContainer,
  SliderContainer,
  MainArea,
  DetailArea,
  MainText,
  Title,
  Description,
  GraphDescription
} from "../../../components/StyledComponents";
import appUrls from "../../../config/appUrls";

class Home extends Component {
  state = {
    detailChosen: "ENTITY",
    dropDownOneOpen: false,
    dropDownTwoOpen: false,
    dropDownData1: [
      {
        id: 0,
        value: 63,
        name: "مراكز الخدمة",
        selected: true
      },
      {
        id: 1,
        value: 28,
        name: "مراكز الإتصال",
        selected: true
      },
      {
        id: 2,
        value: 84,
        name: "قنوات توصيل الخدمة عبر الإنترنت ",
        selected: true
      },
      {
        id: 3,
        value: 24,
        name: "نقاط اتصال تقديم الخدمات",
        selected: true
      },
      {
        id: 4,
        value: 11,
        name: "مركز الخدمة",
        selected: true
      }
    ],
    dropDownData2: [
      {
        id: 0,
        value: 63,
        name: "الإنتاجية",
        selected: true
      },
      {
        id: 1,
        value: 28,
        name: "القدرة الإستيعابية",
        selected: true
      },
      {
        id: 2,
        value: 84,
        name: "زمن الخدمة القياسي",
        selected: true
      },
      {
        id: 3,
        value: 24,
        name: "زمن التقديم",
        selected: true
      },
      {
        id: 4,
        value: 11,
        name: "زمن إتمام الخدمة",
        selected: true
      },
      {
        id: 5,
        value: 83,
        name: "زمن الإنتظار",
        selected: true
      },
      {
        id: 6,
        value: 67,
        name: "إستمرارية الخدمة",
        selected: true
      },
      {
        id: 7,
        value: 95,
        name: "نسبة الإنشغال",
        selected: true
      },
      {
        id: 8,
        value: 18,
        name: "مستوى الثقة",
        selected: true
      },
      {
        id: 9,
        value: 95,
        name: "مستوى سعادة المتعاملين",
        selected: true
      },
      {
        id: 10,
        value: 20,
        name: "معدل جودة الخدمة الكلي",
        selected: true
      },
      {
        id: 11,
        value: 83,
        name: "زمن إنجاز الخدمة",
        selected: true
      },
      {
        id: 12,
        value: 73,
        name: "تكلفة الوحدة من الخدمة",
        selected: true
      }
    ]
  };

  setChosenDetail = detailChosen => {
    this.setState({
      detailChosen
    });
  };

  handlCircleGraphClick = (chosen, field) => {
    let { [field]: data } = this.state;
    let selectedCount = 0,
      isOnlyOneSelected = false;
    let itemIndex = data.findIndex(item => item.id === chosen);
    let isAllSelected = data.every(item => item.selected === true);

    data.forEach(item => {
      if (item.selected === true) selectedCount++;
    });
    if (selectedCount === 1 && data[itemIndex].selected === true)
      isOnlyOneSelected = true;

    if (isAllSelected) {
      data.map(item => {
        if (item.id !== chosen) item.selected = false;
        return item;
      });
    } else if (isOnlyOneSelected) {
      data.map(item => {
        item.selected = true;
        return item;
      });
    } else data[itemIndex].selected = !data[itemIndex].selected;

    this.setState({ [field]: data });
  };

  handleDropdown = field => {
    if (field === "dropDownOneOpen") {
      this.setState(prevState => {
        return { [field]: !prevState[field], dropDownTwoOpen: false };
      });
    } else if (field === "dropDownTwoOpen") {
      this.setState(prevState => {
        return { [field]: !prevState[field], dropDownOneOpen: false };
      });
    } else if (field === "dropDownOneOutside") {
      this.setState({
        dropDownOneOpen: false
      });
    } else if (field === "dropDownTwoOutside") {
      this.setState({
        dropDownTwoOpen: false
      });
    }
  };

  showMoreAction = () => {
    if (this.state.detailChosen === "ENTITY") {
      this.props.push(appUrls.ENTITY_ZOOMED);
    } else {
      this.props.push(appUrls.SECTOR_ZOOMED);
    }
  };

  render() {
    const {
      dropDownOneOpen,
      dropDownTwoOpen,
      dropDownData1,
      dropDownData2
    } = this.state;
    const { theme } = this.props;
    return (
      <Main>
        <GraphDetailContainer>
          <MainArea>
            <GraphDescription>
              {window.innerWidth < 575
                ? "إختار أي قناة خدمة أو جهة حكومية لمعرفة المزيد"
                : "متوسط اداء الخدمات الحكومية لجميع الجهات الحكومية و علاقته بالقطاعات الاستراتيجية"}
            </GraphDescription>
            <Graph
              showMoreAction={this.showMoreAction}
              setChosenDetail={this.setChosenDetail}
            />
            <SliderContainer>
              <Slider theme={theme} />
            </SliderContainer>
          </MainArea>
          <DetailArea>
            <MainText>دليل مؤشر الخدمات الحكومية</MainText>
            <Title>قنوات تقديم الخدمة</Title>
            <Description>
              هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما
              سيلهي القارئ
            </Description>

            <ChannelsDropdown
              dropDownTwoOpen={dropDownTwoOpen}
              dropDownOneOpen={dropDownOneOpen}
              data={dropDownData1}
              handleClick={this.handlCircleGraphClick}
              handleDropdown={this.handleDropdown}
            />
            <IndicatorsDropdown
              dropDownTwoOpen={dropDownTwoOpen}
              dropDownOneOpen={dropDownOneOpen}
              data={dropDownData2}
              handleClick={this.handlCircleGraphClick}
              handleDropdown={this.handleDropdown}
            />

            {/* {dropDownTwoOpen && !dropDownOneOpen && (
              <DropdownGraphContainer2>
                {dropDownData2.map((item, i) => (
                  <DropdownGraphChild
                    key={i}
                    onClick={() =>
                      this.handlCircleGraphClick(item.id, "dropDownData2")
                    }
                    selected={item.selected}
                  >
                    <SecondDropdownGraph>
                      <CircleGraph value={item.value} title={item.name} />
                    </SecondDropdownGraph>

                    <CircleDetail size="small">{item.name}</CircleDetail>
                  </DropdownGraphChild>
                ))}
              </DropdownGraphContainer2>
            )} */}
          </DetailArea>
        </GraphDetailContainer>
      </Main>
    );
  }
}

export default Home;
